import request from '@/utils/request'

// 类型表

let LabelApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.label/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.label/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.label/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.label/edit', data, errorback);
    }
}

export default LabelApi;



// WEBPACK FOOTER //
// ./src/api/study/label.js